<template>
    <div class="content">
        <div id="experience-selector" v-if="showExperiences">
            <minimal-experiences
                :more-info="showMoreInfoExperience"
                :show-experience-name="showExperienceName"
                :show-room-name="showRoomName"
                :multi-booking="multiBooking"
                :call-sunday="callSunday"
                :url-experience="urlInfoExperience"
                @next-step="onNextStepOne"
            />
        </div>
        <div id="calendar-selector" class="minimal-width" v-if="showDateSelection">
            <calendar-selector :call="call" @next-step="onNextStepTwo" @back="onBackSelected"/>
        </div>
        <div id="checkout-final" class="minimal-width" v-if="showCheckout">
            <minimal-checkout @back-step="onModify" :terms="terms"/>
        </div>
        <div v-if="showDateSelection && getTotalPriceCalcutate > 0" class="form-group-price">
            <div class="price-number">
                <span>{{ $t('Precio') }}:</span>
                <span>{{ getTotalPriceCalcutate }}€</span>
            </div>
            <div class="button button-flat" v-if="getCheckout().items[0].start" @click="onNextStepLast">{{ $t('Siguiente') }}</div>
        </div>
        <powered-by />
    </div>
</template>

<script>
    import MinimalExperiences from './experiences/minimal-experiences.vue';
    import CalendarSelector from './calendar-selector/calendar-selector.vue'
    import MinimalCheckout from './checkout/minimal-checkout.vue';
    import PoweredBy from './mini-components/powered-by.vue';
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
import { findPriceForPlayers } from './../helpers';

    export default {
        name: 'minimal-calendar',
        components: {            
            CalendarSelector,
            MinimalExperiences,
            MinimalCheckout,
            PoweredBy
        },
        props: ['integration'],
        data(){
            return {
                call: this.integration.call,
                callSunday: this.integration.sundayCall,
                isAvailableDayShow: false,
                moreInfoText: this.integration.text ?? '',
                minHeight: 0,
                multiBooking: this.integration.multibooking,
                showCheckout: false,
                showDateSelection: false,
                showExperiences: true,
                showExperienceName: this.integration.calname,
                showMoreInfoExperience: this.integration.moreinfo,
                showMoreInfoGeneral: this.integration.info,
                showRoomName: this.integration.line,
                terms: this.integration.terms ?? '',
                urlInfoExperience: JSON.parse(this.integration.urls)
            }
        },
        methods: {
            ...mapMutations(['removeItems']),
            onNextStepOne: function () {
                this.showExperiences = false;
                this.showDateSelection = true;
            },
            onNextStepTwo: function () {
                this.showDateSelection = false;
                this.showCheckout = true;
            },
            onNextStepLast: function(){
                this.showExperiences = false;
                this.showDateSelection = false;
                this.showCheckout = true;
            },
            onBackSelected: function(){
                this.removeItems();
                this.showCheckout = false;
                this.showDateSelection = false;
                this.showExperiences = true;
            },
            onModify: function(){
                this.showCheckout = false;
                this.showDateSelection = true;
            }
        },
        computed: {
            ...mapGetters(['getDesign','getExperiences','getCheckout']),
            getTotalPriceCalcutate: function () {
                let totalPrice = 0;
                let totalPlayers = 0;

                // Recorremos todos los ítems del checkout
                this.getCheckout().items.forEach((item) => {
                    // Solo procesamos los que tengan una fecha/hora de inicio (start)
                    if (item.start) {
                        totalPlayers += item.people_number;

                        // Buscamos la experiencia asociada al ítem
                        const experience = this.getExperiences().find(
                            exp => exp.id === item.id_experience
                        );

                        if (!experience) return;

                        // El precio del numero exacto de jugadores o, si no lo hay, el tramo
                        // general (999). Sin ninguno de los dos se queda a 0 en vez de romper.
                        const matchingPrice = findPriceForPlayers(experience, totalPlayers);
                        const priceToUse = matchingPrice ? matchingPrice.full_price : 0;

                        // Calculamos el total acumulado, en multiprice es necesario multiplicar el precio por le numero de perosnas
                        if(experience.price_type === 'multi_price') {
                           totalPrice = priceToUse * totalPlayers;
                        } else {
                            totalPrice = priceToUse;
                        }  
                    }
                });

                // Devolvemos el total con dos decimales
                return parseFloat(totalPrice).toFixed(2);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/scss/_variables.scss";
    @import "@/scss/_variables_white.scss";
    @import "@/scss/_variables_dark.scss";

    body {
        background-color: #000;
    }

    .content{
        width: 100%;
    }

    .form-group-price {
        padding: 15px 30px;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        background-color: $background-general-more-info-button-white;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .price-number {
            color: #fff;
            text-transform: uppercase;
            span {
                font-size: 35px;
                line-height: 38px;
            }
        }
        .button-flat {
            width: 130px;
        }
    }
</style>
